/**
 * Stock availability. The ERP export carries no warehouse stock yet, so every
 * product is UNKNOWN. This module is the SINGLE point a stock feed replaces:
 * swap the body of `stockStatus` and every consumer (catalog pill and filter,
 * order-approval warning) follows automatically.
 *
 * UNKNOWN is never shown as "out of stock": the catalog draws no pill and no
 * availability filter for it, and an order raises no shortage warning.
 */
export type StockStatus = "IN" | "OUT" | "UNKNOWN";

/**
 * Availability for a SKU. Without a stock source the answer is UNKNOWN for
 * every product; a made-up IN or OUT would tell a customer something nobody
 * measured and would alarm Sales over a shortage that does not exist.
 */
export function stockStatus(_sku: string | null | undefined): StockStatus {
  return "UNKNOWN";
}

/** The subset of the given SKUs that resolve to OUT — drives the order-approval warning. */
export function outOfStockSkus(skus: (string | null | undefined)[]): string[] {
  return skus.filter((s): s is string => stockStatus(s) === "OUT");
}
